import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en/common.json';
import ar from './ar/common.json';

i18n.use(initReactI18next).init({
  resources: {
    en: {
      translation: en,
    },
    ar: {
      translation: ar,
    },
  },
  lng: 'ar',
  fallbackLng: 'ar',
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
